import './FullLayout.scss';
import { DrawerHandle } from '@progress/kendo-react-layout';
import SideNav from 'common/components/layouts/SideNav';
import VeevaCaptureBanner from 'common/components/layouts/VeevaCaptureBanner';
import { createRef } from 'react';

function FullLayout({ children }: Readonly<{ children: React.ReactNode }>) {
  const drawerRef = createRef<DrawerHandle>();

  return (
    <>
      <VeevaCaptureBanner>
        <SideNav drawerRef={drawerRef}>{children}</SideNav>
      </VeevaCaptureBanner>
    </>
  );
}

export default FullLayout;
